// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"290":"c0bf1254","358":"10943a0e","403":"32010704","468":"628ec861","828":"6cc522b3"}[chunkId] + ".chunk.js";
};